// Araç Yükleme (Tüccar Plasiyer) — web tarafı paylaşılan sabitler + biçimlendiriciler.
//
// DURUM MAKİNESİ backend'de kanoniktir: DataScope.Entities/Static/VehicleLoadStatuses.cs (9 durum).
// Eski web kodu 5 durum biliyordu (DRAFT/SUBMITTED/APPROVED/LOADED/CANCELLED) ve:
//   • LOADED artık GELMİYOR  → RECEIVED
//   • RED artık CANCELLED'a düşmüyor → REJECTED (ayrı durum)
// Yeni durumlar rozetsiz kalmasın diye tüm eşleme TEK YERDE burada tutulur; hem liste hem
// detay ekranı buradan okur. LOADED yalnız GERİYE UYUMLULUK için (eski kayıt/mobil) duruyor.
import { StatusBadge } from '../ui';

export const API_BASE = '/api/vehicles/loads';

export const STATUS_META = {
  DRAFT: { label: 'Taslak', tone: 'neutral' },
  SUBMITTED: { label: 'Bekliyor', tone: 'wait' },
  PARTIALLY_APPROVED: { label: 'Revize Onaylı', tone: 'ok' },
  APPROVED: { label: 'Onaylandı', tone: 'ok' },
  REJECTED: { label: 'Reddedildi', tone: 'bad' },
  READY_FOR_PICKUP: { label: 'Teslime Hazır', tone: 'ok' },
  RECEIVED: { label: 'Teslim Alındı', tone: 'ok' },
  RECEIVED_WITH_DIFF: { label: 'Farklı Teslim', tone: 'wait' },
  CANCELLED: { label: 'İptal', tone: 'bad' },
  // Geriye uyumluluk: backfill öncesi kayıtlar / eski mobil sürüm.
  LOADED: { label: 'Teslim Alındı (eski)', tone: 'ok' },
};

export const STATUS_OPTIONS = Object.entries(STATUS_META)
  .filter(([value]) => value !== 'LOADED')
  .map(([value, m]) => ({ value, label: m.label }));

export const REQUEST_TYPE_META = {
  normal: 'Normal',
  ek_yukleme: 'Ek Yükleme',
  acil: 'Acil',
  kampanya: 'Kampanya',
};
export const REQUEST_TYPE_OPTIONS = Object.entries(REQUEST_TYPE_META)
  .map(([value, label]) => ({ value, label }));

export const CREDIT_LIMIT_META = {
  ok: { label: 'Uygun', tone: 'ok' },
  exceeded: { label: 'Aşım', tone: 'bad' },
  not_checked: { label: 'Sorulmadı', tone: 'neutral' },
};
export const CREDIT_LIMIT_OPTIONS = Object.entries(CREDIT_LIMIT_META)
  .map(([value, m]) => ({ value, label: m.label }));

/** Revize gerekçeleri (onaycı satırda miktarı kısınca zorunlu tutulmaz ama sunulur). */
export const REVISION_REASONS = [
  'Stok yetersiz',
  'Kapasite aşımı',
  'Kredi limiti',
  'Kampanya kısıtı',
  'Talep fazlası',
  'Diğer',
];

/** Aksiyon alınabilir mi? (backend VehicleLoadStatuses.IsClosed ile aynı) */
export const isClosedStatus = (st) =>
  st === 'REJECTED' || st === 'CANCELLED' || isReceivedStatus(st);
export const isReceivedStatus = (st) =>
  st === 'RECEIVED' || st === 'RECEIVED_WITH_DIFF' || st === 'LOADED';
export const isApprovedStatus = (st) =>
  st === 'APPROVED' || st === 'PARTIALLY_APPROVED' || st === 'READY_FOR_PICKUP';
/** Onay kuyruğunda mı? (Sadece bekleyenler filtresi bunu kullanır) */
export const isPendingStatus = (st) => st === 'SUBMITTED';

export function pick(obj, ...keys) {
  if (!obj) return undefined;
  for (const k of keys) if (obj[k] !== undefined && obj[k] !== null) return obj[k];
  return undefined;
}
export function unwrap(payload) { return pick(payload, 'Data', 'data') ?? payload; }

export function statusBadge(status) {
  const meta = STATUS_META[status] || { label: status || '-', tone: 'neutral' };
  return <StatusBadge tone={meta.tone}>{meta.label}</StatusBadge>;
}

export function limitBadge(status) {
  if (!status) return '-';
  const meta = CREDIT_LIMIT_META[status] || { label: status, tone: 'neutral' };
  return <StatusBadge tone={meta.tone}>{meta.label}</StatusBadge>;
}

export function formatDateTime(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function formatDate(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '-';
  return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
}

export function formatNumber(value, digits = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '-';
  return n.toLocaleString('tr-TR', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

/** Talebin yükleme tarihi: yeni ShipmentDate, yoksa eski string DeliveryDate. */
export function shipmentDateOf(row) {
  return pick(row, 'shipmentDate', 'ShipmentDate') || pick(row, 'deliveryDate', 'DeliveryDate') || null;
}

/**
 * ONAY DEADLINE'I: plasiyer YÜKLEME GÜNÜ SABAH 04:00'te depoda (spec §0). Onayın o saatten önce
 * bitmiş olması gerekir → deadline = yükleme tarihi 04:00.
 */
export const PICKUP_DEADLINE_HOUR = 4;

export function deadlineOf(row) {
  const raw = shipmentDateOf(row);
  if (!raw) return null;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(PICKUP_DEADLINE_HOUR, 0, 0, 0);
  return d;
}

/**
 * Bekleme süresi (§6.2 — KRİTİK kolon).
 * elapsedMin  → talep gönderildiğinden beri geçen süre (gösterilen değer)
 * remainingMin→ 04:00 deadline'ına kalan süre (RENGİ bu belirler; negatif = deadline geçti)
 * tone        → 'crit' (<2sa veya geçti) | 'warn' (<6sa) | 'normal' | null (kapanmış talep)
 */
export function waitingInfo(row, now = Date.now()) {
  const status = pick(row, 'status', 'Status');
  if (!isPendingStatus(status)) return { elapsedMin: null, remainingMin: null, tone: null, text: '—' };

  const sentAt = pick(row, 'sentAt', 'SentAt') || pick(row, 'createdDate', 'CreatedDate');
  const sent = sentAt ? new Date(sentAt).getTime() : NaN;
  const elapsedMin = Number.isFinite(sent) ? Math.max(0, Math.round((now - sent) / 60000)) : null;

  const deadline = deadlineOf(row);
  const remainingMin = deadline ? Math.round((deadline.getTime() - now) / 60000) : null;

  let tone = 'normal';
  if (remainingMin != null) {
    if (remainingMin <= 120) tone = 'crit';       // 04:00'a 2 saatten az → KIRMIZI
    else if (remainingMin <= 360) tone = 'warn';  // 6 saatten az → sarı
  }

  return { elapsedMin, remainingMin, tone, text: formatDuration(elapsedMin) };
}

export function formatDuration(minutes) {
  if (minutes == null || !Number.isFinite(minutes)) return '—';
  const abs = Math.abs(minutes);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  return `${h}s ${String(m).padStart(2, '0')}dk`;
}

/** Sıralama anahtarı: kapanmış talepler EN ALTA (-1); açıklar bekleme süresine göre desc. */
export function waitingSortKey(row, now = Date.now()) {
  const info = waitingInfo(row, now);
  if (info.elapsedMin == null) return -1;
  return info.elapsedMin;
}

/** Satırda talep edilen miktar (yeni Quantity, yoksa eski RequestedCases). */
export function requestedQtyOf(line) {
  const q = pick(line, 'requestedQuantity', 'RequestedQuantity');
  if (q != null) return Number(q);
  const legacy = pick(line, 'quantity', 'Quantity') ?? pick(line, 'requestedCases', 'RequestedCases');
  return Number(legacy ?? 0);
}
